import { render, staticRenderFns } from "./IdentificationForm.html?vue&type=template&id=11bd756e&scoped=true&"
import script from "./IdentificationForm.ts?vue&type=script&lang=ts&"
export * from "./IdentificationForm.ts?vue&type=script&lang=ts&"
import style0 from "../Identification.scss?vue&type=style&index=0&id=11bd756e&scoped=true&lang=scss&"
import style1 from "./IdentificationForm.scss?vue&type=style&index=1&id=11bd756e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bd756e",
  null
  
)

export default component.exports